/**
 * Created by akirilyuk on 9/27/16.
 */
define(function (require) {
    "use strict";
    var LE = require("app"),
        BaseModel = require("models/BaseModel"),
        BaseCollection = require("collections/BaseCollection"),
        ApiResources = require("assets/data/apiResources.json"),
        LEResourceResolver = require("leResourceResolver"),
        AttachmentModel = {};

    var KEYS = {
        ID: "id",
        BODY_LENGTH: "bodyLength",
        CREATED_BY_EMAIL: "createdByEmail",
        CREATED_BY_NAME: "createdByName",
        CREATED_DATE: "createdDate",
        FILENAME: "filename",
        PARENT_ID: "parentId",
        TIMESTAMP: "timestamp",
        UNSAVED: "unsaved",
        TYPE: "type"
    };
    LE.module("LEConnection", function (LEConnection, LE, Backbone, Marionette, $, _) {

        AttachmentModel = BaseModel.extend({ //extract collection and model in two own data
            resource: ApiResources.ConnectionPanelDownload.Attachment,

            initialize: function () {
                if (this.getParentId()) {
                    this.resource.url = this.resource.url.replace("{caseId}", this.getParentId());
                    this.resource.url = LEResourceResolver.getUrl(this.resource.url);
                }
            },

            _initSaveResource: function () {
                this.resource = ApiResources.ConnectionPanel.Attachments;
                this.resource.url = LE.sessionManager.isAuthenticated() ? this.resource.securedUrl : this.resource.url;
                this.resource.url = this.resource.url.replace("{caseId}", this.getParentId());
                this.resource.url = LEResourceResolver.getUrl(this.resource.url);
            },

            getTimestamp: function () {
                return this.get(KEYS.TIMESTAMP);
            },

            setTimestamp: function (value) {
                this.set(KEYS.TIMESTAMP, value);
            },

            getId: function () {
                return this.get(KEYS.ID);
            },

            getParentId: function () {
                return this.get(KEYS.PARENT_ID);
            },

            setParentId: function (value) {
                if (value && _.isString(value)) {
                    this.set(KEYS.PARENT_ID, value);
                }
            },

            setUnsaved: function (value) {
                this.set(KEYS.UNSAVED, value);
            },

            //override save to init the save resource
            save: function (options, callbacks) {
                this._initSaveResource();
                var baseModel = new BaseModel(this.attributes);
                baseModel.resource = this.resource;
                return baseModel.save(null, callbacks);
            },
            equals: function (otherAttachment) {
                if (otherAttachment.getId() == this.getId()) {
                    return true;
                } else {
                    return otherAttachment.getTimestamp() === this.getTimestamp();
                }
            },
            getType: function () {
                return this.get(KEYS.TYPE);
            }

        });

    });

    return AttachmentModel;
});
